import {Injectable} from '@angular/core';
import { ConnectionBackend,
        RequestOptions,
        Request,
        RequestOptionsArgs,
        Response,
        Http,
        Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { catchError } from 'rxjs/operators';
import { environment } from '../environments/environment';

@Injectable()
export class InterceptedHttp extends Http {
  constructor(backend: ConnectionBackend, defaultOptions: RequestOptions) {
      super(backend, defaultOptions);
  }

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    console.log('My new request...');
    console.log(url);
    console.log(options);

    return super.request(url, options).pipe(
      catchError((error: Response) => {
        if (error.status == 401) {
          window.location.href = environment.restBaseRedirect + 'home';
        }
        return Observable.throw(error);
      })
    );
  }

  get(url: string, flag?: string, options?: RequestOptionsArgs): Observable<Response> {
    console.log('GET');
    if (flag === 'fatturAttiva' ) {
      console.log("Fatturattiva")
      return super.get(url, this.getRequestOptionArgsFA(options));
    } else {
      return super.get(url, this.getRequestOptionArgs(options));
    }
  }


  post(url: string, body: string, flag?: string, options?: RequestOptionsArgs, ): Observable<Response> {
      console.log('POST');

      if (flag === 'payments' ) {
        console.log("si Pagamento")
        return super.post(url, body, this.getRequestOptionArgsPay(options));
      } else {
        console.log("no Pagamento")
        return super.post(url, body, this.getRequestOptionArgs(options));
      }

  }



  put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    console.log('PUT');
      return super.put(url, body, this.getRequestOptionArgs(options));
  }


  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    console.log('DELETE');
    return super.delete(url, this.getRequestOptionArgs(options));
  }

  getRequestOptionArgs(options?: RequestOptionsArgs): RequestOptionsArgs {
    console.log('getRequestOptions');
        if (options == null) {
            options = new RequestOptions();
        }
        if (options.headers == null) {
            options.headers = new Headers();
        }

        //localStorage.setItem("token", "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxNjczIiwiaWF0IjoxNTc0Njc4MzUzLCJleHAiOjE1NzQ3NjQ3NTN9.F-gE32si_wqaKV0ZIuZAmwTP8jM8d_-L_GkrYlgpDZNiqGP2tnWuJ83aaPqV0m-eXQ3v8mtplwD7CFln8IPLjA");
      options.headers.append('X-Auth-Token', localStorage.getItem('token'));
        console.log(options);
        console.log("Token" , localStorage.getItem('token'))


        return options;
    }

  getRequestOptionArgsFA(options?: RequestOptionsArgs): RequestOptionsArgs {
      console.log('getRequestOptionsFA');
      if (options == null) {
          options = new RequestOptions();
      }
      if (options.headers == null) {
          options.headers = new Headers();
      }

      options.headers.append('X-Auth-Token', localStorage.getItem('token'));
      //localStorage.setItem("token", "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxNjU1IiwiaWF0IjoxNTczODM4OTYzLCJleHAiOjE1NzM5MjUzNjN9.bjDNWa_6NQjNB3pDktjrD9b-gLhy9LWJi6MeGe0V-CzbYFG6XgVXX5QvQ1votBGMibk2wqvWCug95O9g5jXtKA");
      options.headers.append('apikey', "12345678");

      return options;
  }

  getRequestOptionArgsPay(options?: RequestOptionsArgs): RequestOptionsArgs {
    console.log('getRequestOptionsPay');
    if (options == null) {
        options = new RequestOptions();
    }
    if (options.headers == null) {
        options.headers = new Headers();
    }

    options.headers.append('Content-Type', 'application/x-www-form-urlencoded');
    console.log(options.headers)
    return options;
  }
}



// WEBPACK FOOTER //
// ./src/app/http.interceptors.ts